import axios from "axios";

export default {
    serviceWorkerStart() {
        if (navigator.serviceWorker) {
            navigator.serviceWorker.register('/serviceWorker.min.js').
                then(function (reg) {
                }).catch(function (error) {
                    console.log(error);
                });

            navigator.serviceWorker.onmessage = function (event) {
                if (event.data.command == "SignOut") {
                    location.reload();
                }
            }
        }
    },
    VerificarPermisos(vm, permiso) {
        var formData = new FormData();
        formData.append("permiso", permiso);
        return vm.axios.post(`${vm.domain.domainNameForApi}VerificarPermiso`, formData).then(response => response.data)
    },
    ObtenerAseguradoras(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}ObtenerAseguradoras`).then(response => response.data);
    },
    ObtenerGrupos(vm, cliente) {
        var formData = new FormData();
        formData.append("cliente", cliente)
        return vm.axios.post(`${vm.domain.domainNameForApi}ObtenerGrupos`, formData).then(response => response.data);
    },
    CambiarAsegFlotilla(vm, datos) {
        var formData = new FormData();
        formData.append("clclave", datos.clclave);
        //if (datos.gfclave !== 0)
        formData.append("gfclave", datos.gfclave);
        return vm.axios.post(`${vm.domain.domainNameForApi}CambiarAsegFlotilla`, formData).then(response => response.data);
    },
    ValidacionContraseña(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Password`).then(response => response);
    },
    Comprobarpassword(vm, passwordanterior, passwordnuevo) {
        var formData = new FormData();
        formData.append("passwordanterior", passwordanterior);
        formData.append("passwordnuevo", passwordnuevo);
        return vm.axios.post(`${vm.domain.domainNameForApi}Comprobarpassword`, formData).then(response => response);
    },
    ObtenerNombre(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}ObtenerNombre`).then(response => response.data);
    },
    ObtenerClienteGrupo(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}ObtenerClienteGrupo`).then(response => response.data);
    }
}